export enum AvailableLanguages {
  en_GB = 'en-GB',
  en_US = 'en-US',
  de = 'de',
}
